import { useEffect, useRef } from 'react';
import { useBlocker } from 'react-router-dom';

interface NavigationGuardProps {
  enabled: boolean;
  confirm: () => Promise<boolean>;
}

export const useNavigationGuard = ({ enabled, confirm }: NavigationGuardProps) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      enabled && currentLocation.pathname !== nextLocation.pathname
  );

  const isConfirming = useRef(false);

  useEffect(() => {
    if (blocker.state === 'blocked' && !isConfirming.current) {
      isConfirming.current = true; // 락(Lock)

      confirm().then((shouldProceed) => {
        if (shouldProceed) {
          blocker.proceed();
        } else {
          blocker.reset();
        }
        isConfirming.current = false;
      });
    }
  }, [blocker.state, confirm]);
};